<ng-container *ngIf="loading; else content">
  <app-loader text="Моля изчакайте..."></app-loader>
</ng-container>

<ng-template #content>
  <app-modal [padding]="'lg'">
    <form [formGroup]="form" (ngSubmit)="onSubmit($event)">
      <app-modal-header
        [showCloseButton]="true"
        [title]="'Подаване на авария'"
        [centerTitle]="true" (closed)="closeModal()">
      </app-modal-header>

      <app-modal-body>
        <section class="row">
          <div class="col">
            <div class="row">
              <div class="col-md-12 col-sm-12">
                <label for="registeredSignalId">Изберете постъпил сигнал с индентифицирана авария: <span class="font-danger">*</span></label>
                <select
                  formControlName="registeredSignalId"
                  class="form-select"
                  (ngModelChange)="onRegisteredSignalSelected($event)"
                >
                  <ng-container *ngFor="let s of closedSignalsList">
                    <option [ngValue]="s.id">
                      {{ s.title }}
                    </option>
                  </ng-container>
                </select>
              </div>
            </div>
          </div>
        </section>

        <ng-container *ngIf="selectedRegisteredSignal">
          <!--Signal info-->
          <section class="row">
            <div class="col">
              <hr class="mt-4 mb-4" />
              <h4>Налична информация за сигнала</h4>
              <!--<div class="row mb-3">
                <div class="col-md-12 col-sm-12">
                  <label class="col-form-label">Тип на аварията:</label>
                  <input class="form-control"
                         type="text"
                         [disabled]="true"
                         [value]="selectedRegisteredSignal.tipAvaria.title" />
                </div>
              </div>-->
              <div class="row mb-3">
                <div class="col-md-12 col-sm-12">
                  <label class="col-form-label">Статус на аварията:</label>
                  <input class="form-control"
                         type="text"
                         [disabled]="true"
                         [value]="getEmergencyStatus()" />
                </div>
              </div>
              <!--<div class="row mb-3">
                <div class="col-md-12 col-sm-12">
                  <label class="col-form-label">Ремонта група:</label>
                  <input class="form-control"
                         type="text"
                         [disabled]="true"
                         [value]="getSignalWorkingGroupTitle(selectedRegisteredSignal.workingGroupsId)" />
                </div>
              </div>-->
              <div class="row mb-3">
                <div class="col-md-6 col-sm-12">
                  <label class="col-form-label">Дата и час на установяване на сигнала:</label>
                  <input class="form-control"
                         type="datetime-local"
                         [disabled]="true"
                         [value]="toLocalDateTime(selectedRegisteredSignal.when)" />
                </div>
                <div class="col-md-6 col-sm-12">
                  <label class="col-form-label">Дата и час на извършена проверка:</label>
                  <input class="form-control"
                         type="datetime-local"
                         [disabled]="true"
                         [value]="toLocalDateTime(selectedRegisteredSignal.checkoutWhen)" />
                </div>
              </div>
            </div>
          </section>

          <!--Emergency-->
          <section class="row">
            <div class="col">
              <hr class="mt-4 mb-4" />
              <h4>Данни за създаване на нова авария</h4>
              <div class="row mb-3">
                <div class="col-md-12 col-sm-12">
                  <label class="col-form-label">Име на аварията: <span class="font-danger">*</span></label>
                  <input
                    formControlName="emergencyTitle"
                    class="form-control"
                    type="text"
                  />
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-12 col-sm-12">
                  <label class="col-form-label">Тип на аварията: <span class="font-danger">*</span></label>
                  <select formControlName="idTipAvaria" class="form-select">
                    <ng-container *ngFor="let item of avariaTypesList">
                      <ng-container *ngIf="item.isActive">
                        <option [ngValue]="item.id">{{ item.title }}</option>
                      </ng-container>
                    </ng-container>
                  </select>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-12 col-sm-12">
                  <label class="col-form-label">Ремонта група: <span class="font-danger">*</span></label>
                  <select formControlName="workingGroupsId" class="form-select">
                    <ng-container *ngFor="let item of wGroupsList">
                      <ng-container *ngIf="item.isActive">
                        <option [ngValue]="item.id">{{ item.title }}</option>
                      </ng-container>
                    </ng-container>
                  </select>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-12 col-sm-12">
                  <label class="col-form-label">Описание на аварията:</label>
                  <textarea
                    rows="5"
                    placeholder="Въведете допълнително описание"
                    class="form-control"
                    formControlName="emergencyDescription"
                    spellcheck="false"
                  >
                  </textarea>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-12 col-sm-12">
                  <label class="col-form-label">Описание на материали:</label>
                  <app-emergency-materials-form-select
                    [availableMaterialsList]="availableMaterialsList"
                    [usedEmergencyMaterialsList]="usedEmegencyMaterialsList"
                    [unitsList]="unitsList"
                    [emergencyId]="emergency?.id"
                    (emergencyMaterialsUpdated)="onEmergencyMaterialsUpdated($event)"
                  >
                  </app-emergency-materials-form-select>
                </div>
              </div>

              <!--<div class="row mb-3">
                <div class="col-md-12 col-sm-12">
                  <label class="col-form-label">Описание на механизация:</label>
                  <app-emergency-mechanisations-form-select
                    [availableMechanisationsList]="availableMechanisationsList"
                    [usedEmergencyMechanisationsList]="usedEmergencyMechanisationsList"
                    (emergencyMechanisationsUpdated)="onEmergencyMechanisationsUpdated($event)"
                  >
                  </app-emergency-mechanisations-form-select>
                </div>
              </div>-->
            </div>
          </section>
          <section class="row">
            <div class="col-md-12 col-sm-12">
              <hr class="mt-4 mb-4" />
              <h4>Местоположение на аварията</h4>
              <label class="col-form-label">Изберете локация на аварията <span class="font-danger">*</span></label>
              <div class="map-container-wrapper">
                <app-map-location-selector
                  [readonly]="false"
                  [location]="incidentLocation"
                  [zoom]="16"
                  (locationUpdated)="onLocationUpdated($event)"
                >
                </app-map-location-selector>
              </div>
            </div>
          </section>

        </ng-container>
      </app-modal-body>

      <app-modal-footer>
        <button
          type="submit"
          name="add_emergency"
          class="btn btn-primary"
          [disabled]="!form.valid">
            {{ emergency ? 'Редактирай' : 'Добави авария' }}
        </button>
      </app-modal-footer>
    </form>
  </app-modal>
</ng-template>
